import { SupportedLocale } from '@src/cnst/translations.cnst'
import { createContext } from 'react'

export interface CampaignProps {
  code?: string
  ignoreConfirmation?: boolean
  locale?: SupportedLocale
}

export type Campaign = CampaignProps | undefined

export const campaignContext = createContext<Campaign>(undefined)
